import { configureStore } from "@reduxjs/toolkit";
import itemReducer from "./slices/itemSlice";
import mediaReducer from "./slices/mediaSlice";
import mapViewReducer from "./slices/mapViewSlice";

export default configureStore({
  reducer: {
    item: itemReducer,
    media: mediaReducer,
    mapData: mapViewReducer
  },
});
